import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import translate from "src/functions/translate";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sSectionHeading } from "src/styles/sSectionHeading.module.scss";
import { CSSTextAlign } from "src/types/CSSTextAlign";

type Props = {
  align?: CSSTextAlign | null | undefined;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
  subtitle: string;
  theme?: "light" | "dark";
  title: string;
};

const SectionHeading = ({
  align,
  className,
  style,
  subtitle,
  theme = "light",
  title,
}: Props) => {
  const { locale: lang } = useRouter();
  return (
    <div
      className={composeClassNames([
        sSectionHeading,
        theme,
        "section-heading",
        className,
      ])}
      style={style}
    >
      <Heading
        align={align}
        className={composeClassNames([sGroupTitle, "section-title"])}
        title={translate(title, lang)}
        type="h2"
        variant="secondary"
      />
      <Paragraph size="md" align={align} className="section-subtitle">
        <Translate tKey={subtitle} />
      </Paragraph>
    </div>
  );
};

export default SectionHeading;
